// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3H_sQ","col":"styles_col__3CqKT","actions":"styles_actions__1Mu6c","conflict":"styles_conflict__h0WIe"};